import muiIcons from "../components/icons/mui-icons";

export const navbarAppList: any = [
  {
    Icon: muiIcons.HomeIcon,
    link: "#",
    text: "Home",
  },
  {
    Icon: muiIcons.LibraryIcon,
    link: "#",
    text: "Ui Kits",
  },
  {
    Icon: muiIcons.DesktopIcon,
    link: "#",
    text: "Apps",
  },
  {
    Icon: muiIcons.UiKitIcon,
    link: "#",
    text: "Form",
  },
  {
    Icon: muiIcons.PersonIcon,
    link: "#",
    text: "Sessions",
  },
  {
    Icon: muiIcons.SupportIcon,
    link: "#",
    text: "Support",
  },
];

export const notificationList = [
  {
    Icon: muiIcons.ChatIcon,
    title: "New message",
    description: "James: Hey! are you busy?",
    time: "2019-10-30T02:10:18.931Z",
    color: "primary.main",
    status: "New",
  },
  {
    Icon: muiIcons.NewsIcon,
    title: "New order received",
    description: "1 Headphone, 3 iPhone",
    time: "2019-03-10T02:10:18.931Z",
    color: "success.main",
    status: "New",
  },
  {
    Icon: muiIcons.InboxIcon,
    title: "Product out of stock",
    description: "1 Headphone, 3 iPhone",
    time: "2019-05-10T02:10:18.931Z",
    color: "warning.main",
    status: "3",
  },
  {
    Icon: muiIcons.ServerIcon,
    title: "Server up!",
    description: "Server rebooted successfully",
    time: "2019-03-10T02:10:18.931Z",
    color: "success.main",
    status: "3",
  },
];

export const SearchDrawerProduct = [
  {
    name: "Headphone 1",
    category: "Gadget",
    currentPrice: 300,
    prevPrice: 400,
    status: "Sale",
    imgUrl: "/assets/images/products/headphone-1.jpg",
  },
  {
    name: "Bitz Headphone 1",
    category: "Gadget",
    currentPrice: 300,
    prevPrice: 400,
    status: "New",
    imgUrl: "/assets/images/products/headphone-2.jpg",
  },
  {
    name: "Sony Headphone 1",
    category: "Gadget",
    currentPrice: 300,
    prevPrice: 400,
    status: "New",
    imgUrl: "/assets/images/products/headphone-3.jpg",
  },
  {
    name: "Earphone 1",
    category: "Gadget",
    currentPrice: 300,
    prevPrice: 400,
    status: "New",
    imgUrl: "/assets/images/products/headphone-4.jpg",
  },
];

export const tableDataList = [
  {
    name: "Smith Doe",
    email: "Smith@gmail.com",
    status: "active",
    photoUrl: "/assets/images/faces/1.jpg",
    gf: "/assets/images/faces/1.jpg",
  },
  {
    name: "Jhon Doe",
    email: "Jhon@gmail.com",
    status: "pending",
    photoUrl: "/assets/images/faces/2.jpg",
  },
  {
    name: "Alex",
    email: "Otttio@gmail.com",
    status: "inactive",
    photoUrl: "/assets/images/faces/3.jpg",
  },
];

export const twoColumnTableData = [
  {
    name: "Portable Speaker",
    status: "+ $1200",
  },
  {
    name: "Portable Headphe",
    status: "In Stock",
  },
  {
    name: "Speaker",
    status: "Out of Stock",
  },
  {
    name: "Watch",
    status: "Low Stock",
  },
];
